<template>
    <DFormRow
        :label="__('customers.contracts.external_order')"
        :error="errors.order_id"
        :hint="__('customers.contracts.external_order_helper_text')"
    >
        <DSelect
            id="order_id"
            :model-value="props.modelValue"
            :options="props.orders"
            @update:modelValue="updateModelValue"
        />
    </DFormRow>
</template>

<script setup>

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    orders: {
        type: Array,
        default: () => { return [] }
    },
    modelValue: {
        type: [String, Number],
        default: null
    }
})

const emit = defineEmits(['update:modelValue'])

function updateModelValue ($event) {
    emit('update:modelValue', $event)
}

</script>
